// extracted by mini-css-extract-plugin
export default {"card-basic":"CardBasic_card-basic__ZrfVQ","address":"CardBasic_address__VI+GX","card-basic-left":"CardBasic_card-basic-left__C80q+"};